import React from 'react';
import './MoreInfo.css';

const MoreInfo = ({ translations }) => {
  return (
    <div className='more-info-container'>
      <div>
        <h2>Quanto velocemente posso ricevere il mio premio?</h2>
      </div>
      <div>
        Di solito puoi completare tutte le offerte sponsorizzate richieste entro 5-7 giorni 
        (alcune potrebbero richiedere fino a 60 giorni per essere completate). Una volta 
        completato il numero richiesto di offerte, devi completare il processo di richiesta 
        dell'incentivo, che richiede la verifica dell'identità. In genere il nostro team di 
        assistenza clienti impiega 5-7 giorni per verificare e consegnare il tuo incentivo.
      </div>
    </div>
  );
};

export default MoreInfo;
